import React from "react";
import { Helmet } from "react-helmet";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import Footer from "../../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../../components/Common/ScrollTop";
import Newsletter from "../../../components/Common/Newsletter";
import Header from "../../../components/Layout/Header/Header";
import ServiceCard from "../../../components/Service/ServiceCard";
import { Link } from "react-router-dom";

import { FaUserTie, FaProjectDiagram, FaUsers, FaChartLine, FaRoad, FaCogs, FaShieldAlt, FaLightbulb } from "react-icons/fa";

import bannerbg from "../../../assets/img/breadcrumbs/sssss.jpg";
import Logo from "../../../assets/img/logo/dark-logo.png";
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import favIcon from "../../../assets/img/fav.png";
import IndustriesSection from "../../home/IndustriesSection";

const serviceCards = [
    {
        icon: <FaProjectDiagram size={80} color="var(--brand-primary)" />,
        title: "Technology Strategy & Roadmap",
        description: "Define clear technology vision and execution roadmap aligned with business goals. We help you prioritize initiatives, allocate resources effectively, and navigate technical decisions.",
    },
    {
        icon: <FaCogs size={80} color="var(--brand-primary)" />,
        title: "Architecture & Technical Leadership",
        description: "Expert guidance on system architecture, technology stack selection, and technical design decisions. We ensure your technical foundation supports current needs and future growth.",
    },
    {
        icon: <FaUsers size={80} color="var(--brand-primary)" />,
        title: "Team Structure & Hiring",
        description: "Build high-performing engineering teams with the right structure, roles, and talent. We help you hire, onboard, and organize teams for maximum productivity and collaboration.",
    },
    {
        icon: <FaChartLine size={80} color="var(--brand-primary)" />,
        title: "Delivery Governance",
        description: "Establish processes, metrics, and governance frameworks that ensure consistent, quality delivery. We implement agile practices and engineering standards that scale with your team.",
    },
    {
        icon: <FaShieldAlt size={80} color="var(--brand-primary)" />,
        title: "Security & Compliance Strategy",
        description: "Develop comprehensive security strategies and ensure regulatory compliance. We help you build security into your culture and processes from the ground up.",
    },
    {
        icon: <FaRoad size={80} color="var(--brand-primary)" />,
        title: "Product & Engineering Alignment",
        description: "Bridge the gap between product vision and technical execution. We ensure engineering efforts are aligned with product strategy and business outcomes.",
    },
    {
        icon: <FaLightbulb size={80} color="var(--brand-primary)" />,
        title: "Innovation & R&D",
        description: "Identify emerging technologies and innovation opportunities relevant to your business. We help you experiment, validate, and adopt new technologies strategically.",
    },
    {
        icon: <FaUserTie size={80} color="var(--brand-primary)" />,
        title: "Vendor & Partner Management",
        description: "Evaluate, select, and manage technology vendors and partners. We help you make informed decisions and get maximum value from external relationships.",
    },
];

const CTOAsAService = () => {
    return (
        <React.Fragment>
            <Helmet>
                <link rel="icon" href={favIcon} />
                <title>CTO-as-a-Service - Syrol Tech</title>
                <meta name="description" content="On-demand technology leadership covering architecture strategy, technical roadmaps, team structure, delivery governance, and engineering best practices." />
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="pages"
                secondParentMenu="others"
                headerNormalLogo={Logo}
                headerStickyLogo={Logo}
                CanvasLogo={Logo}
                mobileNormalLogo={Logo}
                CanvasClass="right_menu_togle hidden-md"
                headerClass="full-width-header header-style1 home8-style4"
                TopBar="enable"
                TopBarClass="topbar-area home8-topbar"
                emailAddress="hello@syroltech.com"
                Location="Abuja, Nigeria"
            />
            <SiteBreadcrumb
                pageTitle="CTO-as-a-Service"
                pageName="CTO-as-a-Service"
                breadcrumbsImg={bannerbg}
            />
            <section className="consultation-hero-section position-relative w-100" style={{ minHeight: '420px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: `url(${bannerbg}) center/cover no-repeat` }}>
                <div className="hero-overlay" style={{ position: 'absolute', inset: 0, background: 'rgba(10, 18, 32, 0.72)', zIndex: 1 }}></div>
                <div className="container position-relative" style={{ zIndex: 2, maxWidth: '900px', padding: '3rem 1rem', textAlign: 'left' }}>
                    <h1 style={{ color: '#fff', fontWeight: 700, fontSize: '2.6rem', lineHeight: 1.15, marginBottom: '1.2rem' }}>Get expert technology leadership on demand</h1>
                    <p style={{ color: '#fff', fontSize: '1.25rem', maxWidth: '600px', marginBottom: '2.2rem' }}>On-demand technology leadership covering architecture strategy, technical roadmaps, team structure, delivery governance, and engineering best practices.</p>
                    <Link to="/consultation" className="readon orange-btn" style={{ padding: '12px 28px', fontSize: '1rem', borderRadius: '6px', fontWeight: 700, textDecoration: 'none', display: 'inline-block', transition: 'background 0.2s' }}>Request A Free Proposal</Link>
                </div>
            </section>
            <div className="rs-contact style1 event-bg pt-110 md-pt-10 pb-100 md-pb-80">
                <div className="container pb-66 md-pb-46">
                    <h2 className="service-title mb-32">Our CTO-as-a-Service Offerings</h2>
                    {serviceCards.map((card, idx) => (
                        <ServiceCard
                            key={idx}
                            icon={card.icon}
                            title={card.title}
                            description={card.description}
                        />
                    ))}
                </div>
            </div>
            <IndustriesSection />
            <Newsletter
                sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
                titleClass="title mb-0 white-color"
            />
            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />
            <SearchModal />
            <ScrollToTop scrollClassName="scrollup orange-color" />
        </React.Fragment>
    );
};

export default CTOAsAService;
